import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
import { MsalAuthService } from './core/services/msal-auth.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
// //test
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MatProgressSpinner],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('KS-dsp-spa');
  private msalService = inject(MsalService);
  private msalBroadcastService = inject(MsalBroadcastService);
  public msalAuth = inject(MsalAuthService);
  public isMsalInitialized = false;
  private readonly _destroying$ = new Subject<void>();
  public ssoInProgress = false;
  imageLoaded = false;

   async ngOnInit(): Promise<void> {
    this.msalAuth.ssoRedirectInProgress$.pipe(takeUntil(this._destroying$))
    .subscribe(value => this.ssoInProgress = value);

    await this.msalAuth.initMsal();

    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.INITIALIZE_START),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      console.log('MSAL Initialization started');
    });

    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.INITIALIZE_END),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.msalService.instance.enableAccountStorageEvents();
    });

    this.msalBroadcastService.inProgress$
      .pipe(takeUntil(this._destroying$))
      .subscribe(status => {
        console.log('MSAL Interaction Status:', status);
        if (status === InteractionStatus.Login) {
          this.msalAuth.setSsoEvent('login');
        }  else if (status === InteractionStatus.Logout) {
          this.msalAuth.setSsoEvent('logout');
        } else if (status === InteractionStatus.None) {
          this.msalAuth.setSsoEvent('redirect');
        }
        localStorage.setItem('sso_event', status);
        if (status === InteractionStatus.Logout) {
          this.msalAuth.startSSORedirect();
        }
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}